import Image from "next/image";
import React, { Fragment } from "react";

const SessionModals = () => {
  return (
    <Fragment>
      <div
        className="modal fade"
        id="calendarSession"
        tabIndex="-1"
        aria-labelledby="calendarSessionLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-overlay">
                <div className="modal-header">
                  <h4 className="text-danger" id="sessionHeading">
                    Session Details
                  </h4>
                </div>

                <div className="rbt-card">
                  <div className="row g-5">
                    <div className="col-md-5 d-flex justify-content-center align-items-center">
                      <Image
                        width={400}
                        height={400}
                        src="https://ik.imagekit.io/Yash/Icons/customer-support_DDK02f1PJ.png?updatedAt=1726920558834"
                        className="img-fluid rounded-circle"
                        alt="Session Image"
                        id="sessionImage"
                      />
                    </div>

                    <div className="col-md-7">
                      <div className="card-body">
                        <h6 className="card-title text-danger mt-3">
                          Live interactive class name:
                        </h6>
                        <strong id="sessionTitle"></strong>
                        <div className="card-text mt-1">
                          <strong className="me-2">Date:</strong>
                          <span id="sessionDate">18-09-2024</span>
                        </div>
                        <div className="card-text mt-1">
                          <strong className="me-2">From:</strong>
                          <span id="sessionFrom"> 09:00 PM</span>{" "}
                          <span className="mx-2">|</span>
                          <strong className="me-2">To:</strong>
                          <span id="sessionTo"> 10:00 PM</span>
                        </div>
                        <div className="card-text mt-1">
                          <strong className="me-2">Subject:</strong>
                          <span id="sessionSubject">18-09-2024</span>
                        </div>
                        <div className="card-text mt-1">
                          <strong className="me-2">Session Description:</strong>
                          <p id="sessionDescription"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="top-circle-shape"></div>
            <div className="modal-footer pt--30">
              <button
                id="sessionDownloadBtn"
                className="rbt-btn btn-sm btn-border radius-round-10"
                type="button"
              >
                Download Notes
              </button>
              <a id="sessionLink" href="#">
                <button
                  type="button"
                  className="rbt-btn btn-sm radius-round-10"
                  data-bs-dismiss="modal"
                >
                  Join Session
                </button>
              </a>
              <button
                type="button"
                className="rbt-btn btn-border btn-sm radius-round-10"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default SessionModals;
